import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  useNotify,
  useRedirect,
  usePermissions,
  useDataProvider,
} from "react-admin";
import { apiUrl } from "../apiendpoint";

import { useEffect, useState } from "react";

const UserGuideAssignmentCreate = () => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();

  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState(null);
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    fetch(`${apiUrl}user/all`)
      .then((res) => res.json())
      .then((data) => {
        setUsers(
          data.map((u) => ({
            id: u.email,
            email: u.email,
            name: `${u.first_name || ""} ${u.last_name || ""}`.trim(),
          }))
        );
      })
      .catch(() =>
        notify("Failed to load users", { type: "error" })
      );
  }, [notify]);

useEffect(() => {
  dataProvider
    .getList("user-guides", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "DESC" },
      filter: {},
    })
    .then(({ data }) => {
      setGuides(
        data.map((g) => ({
          id: g.id,
          title: g.title,
        }))
      );
    })
    .catch(() =>
      notify("Failed to load user guides", { type: "error" })
    );
}, [dataProvider, notify]);

  if (
    !(
      permissions.includes("user-guides.create") ||
      permissions.includes("user-guides.*")||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  const handleSubmit = async (values) => {
    try {
      if (!email) {
        notify("Please select user", { type: "warning" });
        return;
      }

      await dataProvider.create("user-guide-assignments", {
        data: {
          email: email, // ✅ matches backend
          user_guide_id: values.user_guide_id,
        },
      });

      notify("User guide assigned successfully 🎉", {
        type: "success",
      });

      redirect("/user-guide-assignments");

    } catch (error) {
      notify(error.message || "Error", { type: "error" });
    }
  };

  return (
    <Create title="Assign User Guide">
      <SimpleForm onSubmit={handleSubmit}>
        <AutocompleteInput
          source="email_select"
          label="User Email"
          choices={users}
          optionText="email"
          optionValue="email"
          onChange={(value) => setEmail(value)}
          fullWidth
        />
        

        <AutocompleteInput
          source="user_guide_id"
          label="User Guide"
          choices={guides}
          optionText="title"
          optionValue="id"
          fullWidth
/>
      </SimpleForm>
    </Create>
  );
};

export default UserGuideAssignmentCreate;